import { render, staticRenderFns } from "./RectoplusButton.vue?vue&type=template&id=1c79305a&"
import script from "./RectoplusButton.vue?vue&type=script&lang=js&"
export * from "./RectoplusButton.vue?vue&type=script&lang=js&"
import style0 from "./RectoplusButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports